import TurnstileModule from 'react-turnstile'

type TurnstileComponent = typeof TurnstileModule
type TurnstileInteropModule = {
  default?: TurnstileComponent
  Turnstile?: TurnstileComponent
}

const turnstileModule = TurnstileModule as TurnstileComponent &
  TurnstileInteropModule

export const Turnstile =
  turnstileModule.default ?? turnstileModule.Turnstile ?? TurnstileModule
